import { getIconProps, type IconProps } from '#types'

/**
 * Download icon — downward arrow over a curved tray base.
 *
 * Used for download actions (download receipt, export file, etc.).
 *
 * @example
 * ```tsx
 * <button>
 *   <DownloadIcon className="h-5 w-5" /> Download Receipt
 * </button>
 * ```
 */
export function DownloadIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M21 11C21 16.525 17.625 21 12 21C6.375 21 3 16.525 3 11"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.0714L12 14M12 14L8 10.0714M12 14L12 3"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
